// extracted by mini-css-extract-plugin
export default {"logo":"questionnaire_logo__b61vV","main":"questionnaire_main__N0FEb","message":"questionnaire_message__HfoRd"};